<template>
    <div class="technology">
        <div class="pop_close" @click="popclose">
            <img v-if="theme === 2" src="@/assets/popcloseW.svg">
            <img v-else src="@/assets/popcloseB.svg">
        </div>
        <div class="qian">
            <div class="qian_name">前端技术</div>
            <div class="qian_type">
                <div v-for="j, index in technology_qian" :key="index" class="jie_item">
                    <div>{{ j }}</div>
                    <div v-if="index + 1 !== technology_qian.length" class="heng">|</div>
                </div>
            </div>
        </div>
        <div class="qian">
            <div class="qian_name">后端技术</div>
            <div class="qian_type">
                <div v-for="j, index in technology_hou" :key="index" class="jie_item">
                    <div>{{ j }}</div>
                    <div v-if="index + 1 !== technology_hou.length" class="heng">|</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineEmits, ref, computed } from 'vue'
import { useStore } from 'vuex'
const emit = defineEmits(['updateData'])
const popclose = () => {
    emit('popclose')
}
const store = useStore()

const technology_qian = computed(() => { return store.state.app.sysinfo.technology_qian })
const technology_hou = computed(() => { return store.state.app.sysinfo.technology_hou })
const theme = computed(() => { return store.state.app.theme })


</script>

<style lang="scss" scoped>
.technology {
    width: 20rem;
    height: 20rem;
    border-radius: 1rem;
    background: var(--aboutpop-bac);
    border: 1px solid var(--carditem-item-border1);
    position: absolute;
    top: 5rem;
    right: 16rem;
    animation: popin .7s ease-in forwards;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >div {
        flex: 1;
    }

    .qian {
        width: inherit;
        padding-top: 2rem;
        padding-left: 2rem;

        .qian_name {
            font-size: 1.2rem;
            // font-style: italic;
        }

        .qian_type {
            margin-top: 1rem;
            display: flex;
            font-size: .7rem;
            flex-flow: wrap;

            .jie_item {
                display: flex;
                color: #958f8fd9;
                font-size: .8rem;
                padding: .3rem;
            }

            .heng {
                color: #b0b0b057;
                margin: 0 10px;
            }
        }
    }

    .hou {}
}
</style>